/* eslint-disable */
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import moment from 'moment'
import TextInput from '../../containers/Forms/components/TextInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import { getName, getPrescriptionOptionLabel } from '../../containers/Utilities'
import {
  ALL_RECORDINGS_TRIGGER_OPTION,
  CUSTOM_TRIGGER_OPTION,
  getPrimaryTriggerOptions,
  TRIAGE_OPTION,
  ENROLLMENT_CONNECTION_STATUSES,
  getDateFormat,
} from '../../constants'
import { filterBillingCodesCanBeBillable } from '../../store/appReducer'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import { requiredValidation } from '../../containers/Forms/components/formValidations'
import styles from './Forms.css'
import EditIcon from 'static/images/edit.svg'
import CancelIcon from 'static/images/icons/block.svg'
import PrintIcon from 'static/images/icons/print.png'
import SaveIcon from 'static/images/icons/content-save.svg'
import FormattedDate from '../../components/FormattedDate'
import Loading from '../../components/Loading'
import Popover from '../../containers/Popovers/components/Popover'
import {STUDY_DURATION, STUDY_DURATION_DAY_EVENT_MCT} from '../../../views/constsnts/patientEnrollmentConstants'

class EnrollmentForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: {
        ekgReviewWhichRecordings: true,
        ekgReviewWhereRecordings: true,
        icd10Codes: true,
        billingCodes: true,
        orderNumber: true,
        idtfDuration: true,
        device_serial_number: true,
      },
      revokeConfirmShow: false,
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucceeded !== this.props.submitSucceeded && nextProps.submitSucceeded === true) {
      this.setState({
        disabled: {
          ekgReviewWhichRecordings: true,
          ekgReviewWhereRecordings: true,
          icd10Codes: true,
          billingCodes: true,
          orderNumber: true,
          idtfDuration: true,
          device_serial_number: true,
        },
        revokeConfirmShow: false,
      })
    }
  }
  toggleDisable = field => {
    this.setState(prevState => ({
      disabled: Object.assign(prevState.disabled, {
        [field]: !prevState.disabled[field],
      }),
    }))
  }

  // print the Overview page without Print Button(Hide)
  printPage = () => {
    const printContents = document.getElementById('formPrint').innerHTML
    const printWindow = window.open('', '_blank')
    printWindow.document.write(printContents)
    // when we are opening the print contents in new tab, styles were missing, so we are adding the styles explicitly.
    printWindow.document.head.innerHTML = document.head.innerHTML
    printWindow.document.querySelector('button').style = 'display:none'
    // same as styles images are also not loading, so we are appending the src explicitly
    printWindow.document.getElementById('qrCodeImage').src = document.getElementById('qrCodeImage').src
    // in order to stop the window infinite loading, we are stopping the page load after 100ms, mean while image will load.
    setTimeout(() => {
      printWindow.stop()
      printWindow.print()
    }, 100)
  }

  // popover functions here for now, should move later
  // same as cancel on edit member form
  toggleRevokePopover = () => {
    this.setState(prevState => ({
      revokeConfirmShow: !prevState.revokeConfirmShow,
    }))
  }
  cancelRevoke = () => {
    this.setState({
      revokeConfirmShow: false,
    })
  }
  render() {
    const {
      handleSubmit,
      showRevoke,
      handleOnRevokeClick,
      enrollmentFormData,
      physicians,
      triggers,
      invalid,
      pristine,
      submitting,
      billingCodes,
      icd10Codes,
      connectionStatus,
      isSubmitting,
      initialValues: {
        startDate,
        endDate,
        connectionTemplateName,
        duration,
        idtfDuration,
        device_serial_number,
      },
      me,
      isIdtfEnabled,
      isIdtfServiceEnabled,
      pateintEnrollOverview,
      handleIdtfRevokeClick,
      handleIdtfETClick,
    } = this.props
    const {
      disabled,
      revokeConfirmShow,
    } = this.state

    // console.log('initial values', this.props.initialValues)
    const dateFormat = getDateFormat(me)
    const idtfFlag = true

    let physiciansOptions = [
      TRIAGE_OPTION,
    ]
    let triggerOptions = []
    let billingOptions = []
    let icd10Options = []

    if (physicians && physicians.data) {
      physiciansOptions = [ ...physiciansOptions, ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id]) ]
    }

    if (triggers && triggers.data) {
      triggerOptions = [ ...triggerOptions, ...getPrimaryTriggerOptions(triggers.data) ]
    }

    if (billingCodes && billingCodes.data) {
      billingOptions = [ ...billingOptions, ...filterBillingCodesCanBeBillable(billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])) ]
    }

    if (icd10Codes && icd10Codes.data) {
      icd10Options = [ ...icd10Options, ...icd10Codes.data.sortedByName.map(id => icd10Codes.data.byId[id]) ]
    }

    const enrollmentData = pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data.latest_enrollment
    const enrollmentFlag = pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data.has_active_enrollment

    const isCustomSelected = enrollmentFormData && enrollmentFormData.ekgReviewWhichRecordings && enrollmentFormData.ekgReviewWhichRecordings.id === CUSTOM_TRIGGER_OPTION.id
    let isPossibleAFibResultWithHrCheckmarked = false
    let isHeartRateUnderCheckmarked = false
    let isHeartRateOverCheckmarked = false

    let isKM6L = false
    let isKardiaPatch = false
    let rpmUser = false
    if(isIdtfEnabled) {
      if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data['latest_enrollment']) {
        isKM6L = pateintEnrollOverview.data.latest_enrollment.device == 'KM6L'
        isKardiaPatch = pateintEnrollOverview.data.latest_enrollment.device == 'kardiaPatch'
      }
      else {
        rpmUser = true
      }
    }

    if (enrollmentFormData) {
      if (enrollmentFormData.custom) {
        const {
          custom,
        } = enrollmentFormData

        isPossibleAFibResultWithHrCheckmarked = custom.possibleAFibResultWithHrCheckmark
        isHeartRateUnderCheckmarked = custom.heartRateUnderCheckmark
        isHeartRateOverCheckmarked = custom.heartRateOverCheckmark
      }
    }

    const renderEnrollmentDates = () => {
      const content = []
      const hasStartAndEnd = startDate && endDate
      const hasStartOnly = startDate && !endDate
      const hasNoDates = !startDate && !endDate

      if (hasNoDates) {
        content.push('-')
      }

      if (hasStartAndEnd) {
        content.push((
          <span key={1}>
            <FormattedDate
              date={startDate}
              fmt={dateFormat}
              me={me}
            /> to&nbsp;
            <FormattedDate
              date={endDate}
              fmt={dateFormat}
              me={me}
            />
          </span>
        ))
      }

      if (hasStartOnly) {
        content.push((
          <span key={2}>
            <FormattedDate
              date={startDate}
              fmt={dateFormat}
              me={me}
            /> to (no end date)
          </span>
        ))
      }
      return content
    }

    const STUDY_SERVICE_TYPE = [
      { value: 'event', label: 'Event' },
      { value: 'holter', label: 'Holter' },
      { value: 'extHolter', label: 'Extended Holter' },
      { value: 'mct', label: 'MCT' }
    ];

    STUDY_SERVICE_TYPE.map((item) => {
      if(enrollmentData && enrollmentData.service_type == item.value) {
        enrollmentData.service_type = item.label
      }
    })

    const userCreatedBy = enrollmentData && enrollmentData.enrollment_created_by == "" || null ? '<>' : enrollmentData && enrollmentData.enrollment_created_by
    const userCreatedAt = enrollmentData && enrollmentData.enrollment_created_at == "" || null ? '<>' : enrollmentData && moment(enrollmentData.enrollment_created_at).format(getDateFormat())
    const referringPhysicaian = enrollmentData && enrollmentData.ordering_physician == "" || null ? '<>' : enrollmentData && enrollmentData.ordering_physician

    const getEditClassName = field => (disabled[field] ? 'editIcon' : 'editIconActive')

    const renderRevokeContent = () => {
      let revokeContent

      switch (connectionStatus) {
      case ENROLLMENT_CONNECTION_STATUSES.CONNECTED:
        revokeContent = (
          <React.Fragment>
            <div className={styles.dropoverContent}>
              <h2>
                Are you sure you want to revoke this patient’s connection?
              </h2>
              <p>
                Any new recordings done by the patient will not be added to their file for review until a new connection plan is set up.
              </p>
            </div>
            <div className={styles.dropoverControls}>
              <a onClick={() => this.cancelRevoke()}>
                Cancel
              </a>
              <a onClick={handleOnRevokeClick}>
                Yes, Revoke
              </a>
            </div>
          </React.Fragment>
        )
        break
      case ENROLLMENT_CONNECTION_STATUSES.PENDING:
        revokeContent = (
          <React.Fragment>
            <div className={styles.dropoverContent}>
              <h2>
                Are you sure?
              </h2>
              <p>
                Revoking will mark the patient's referral code as invalid. In order to connect the patient, you will need to set up a new connection plan.
              </p>
            </div>
            <div className={styles.dropoverControls}>
              <a onClick={() => this.cancelRevoke()}>
                Cancel
              </a>
              <a onClick={handleOnRevokeClick}>
                Yes, Revoke
              </a>
            </div>
          </React.Fragment>
        )
        break
      default:
        break
      }

      return revokeContent
    }

    const getConnectionEnrollemntStatus = connection_status => {
      const buttonState = {
        show: false, // show/hide
        revoke: true, // false for early termination
      };
    
      switch (connection_status && connection_status.toLowerCase()) {
        case 'pending':
        case 'enrolled':
          buttonState.show = true;
          buttonState.revoke = true;
          break;
        case 'revoked':
        case 'complete':
        case 'expired':
          buttonState.show = false;
          break;
        case 'active':
          buttonState.show = true;
          buttonState.revoke = false;
          break;
        default:
          break;
      }
      return buttonState;
    }
    const buttonState = getConnectionEnrollemntStatus(enrollmentData && enrollmentData.enrollment_status)

    const renderIdtfRevokeContent = () => {
      let revokeContent
        revokeContent = (
          buttonState.show == true && buttonState.revoke == true ?
          <React.Fragment>
            <div className={styles.dropoverContent}>
              <h2>
                Are you sure?
              </h2>
              <p>
                Revoking will mark the patient's referral code as invalid. In order to connect the patient, you will need to set up a new connection plan.
              </p>
            </div>
            <div className={styles.dropoverControls}>
              <a onClick={() => this.cancelRevoke()}>
                Cancel
              </a>
              <a onClick={handleIdtfRevokeClick}>
                Yes, Revoke
              </a>
            </div>
          </React.Fragment> :
          <React.Fragment>
          <div className={styles.dropoverContent}>
            <h2>
              Are you sure?
            </h2>
            <p>
                Terminating will mark the patient's referral code as invalid. In order to connect the patient, you will need to set up a new connection plan.
            </p>
          </div>
          <div className={styles.dropoverControls}>
            <a onClick={() => this.cancelRevoke()}>
              Cancel
            </a>
            <a onClick={handleIdtfETClick}>
              Yes, Terminate
            </a>
          </div>
        </React.Fragment>
        )
      return revokeContent
    }

    return (
      <form onSubmit={handleSubmit}>
        {
          ((isIdtfEnabled) && (enrollmentFlag) && (enrollmentData)) ?
          <div style= { {display: 'flex'} } className={styles.editEnrollmentSection}>
          <div>
          <div className={styles.formSectionRow}>
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Study Type</span>
                <div className={styles.fakeInput}>
                  {enrollmentData && enrollmentData.service_type}
                </div>
              </div>
            </div>
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('idtfDuration')]} onClick={() => this.toggleDisable('idtfDuration')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Duration"
                  name="idtfDuration"
                  placeholder="Select a duration"
                  noOptionsMessage="No Duration found"
                  options={STUDY_DURATION_DAY_EVENT_MCT}
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.value}
                  disabled={disabled.idtfDuration}
                />
            </div>
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Enrollment Date</span>
                <div className={styles.fakeInput}>
                  {moment(enrollmentData && enrollmentData.enrollment_date).format('MM-DD-YYYY')}
                </div>
              </div>
            </div>
            
          </div>
          <div className={styles.formSectionRow}>
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Hookup Type</span>
                <div className={styles.fakeInput}>
                  {enrollmentData && enrollmentData.hookup_type}
                </div>
              </div>
            </div>
            { enrollmentFlag && enrollmentData && enrollmentData.device !== 'KM6L' &&
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            <div className={styles[getEditClassName('device_serial_number')]} onClick={() => this.toggleDisable('device_serial_number')}>
              <EditIcon />
            </div>
            <Field
              component={TextInput}
              label="Serial Number"
              name="device_serial_number"
              disabled={disabled.device_serial_number}
            />
            </div>
            
            // <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            //   <div className={styles.noEditIcon} />
            //   <div className={styles.inputGroup}>
            //     <span className={styles.label}>Serial Number</span>
            //     <div className={styles.fakeInput}>
            //       {enrollmentData && enrollmentData.device_serial_number}
            //     </div>
            //   </div>
            // </div>
            }
            <div style={{ display: 'block' }} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Referring Physician</span>
                <div className={styles.fakeInput}>
                  {enrollmentData && enrollmentData.referring_physician_member}
                </div>
              </div>
            </div>
          </div>
          {
          enrollmentData.service_type == 'MCT' &&
          <div>
          <div className={styles.autoTriggers}>
            Auto Triggers
          </div>
          <div style={{ width: '650px', display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'block' }} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>TACHYCARDIA</span>
                <div className={styles.fakeInput}>
                  130
                </div>
              </div>
            </div>
            <div style={{ display: 'block'}} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>BRADYCARDIA</span>
                <div className={styles.fakeInput}>
                  30
                </div>
              </div>
            </div>
            </div>
            <div style={{ width: '650px', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'block'}} className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>PAUSE</span>
                <div className={styles.fakeInput}>
                  3.0
                </div>
              </div>
            </div>
            <div style={{ display: 'block', marginRight: '35px'}} className={styles.editLabelGrou}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>A FIB</span>
                <div className={styles.fakeInput}>
                  ON
                </div>
              </div>
            </div>
            </div>
            </div>}
          <div className={styles.formSectionRow}>
            {isIdtfEnabled && enrollmentFlag && enrollmentData && <div style={{ display: 'block', margin: 'auto' }} className={styles.editLabelGroupForEnroll}>
            {submitting || isSubmitting ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              <button
                type="submit"
                disabled={invalid || pristine}
                className={styles.submit}
                data-action="button-edit-order"
                data-label="save"
              >
                <SaveIcon />
                Save
              </button>
            }
              </div>}
              </div>
          </div>
          {isIdtfEnabled && enrollmentFlag && enrollmentData &&
            <div style={{ display: 'block' }} className={styles.editLabelGroupForEnroll}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Indication</span>
                <div style={{ width: '250px'}} className={styles.fakeInputIndication}>
                  <ul>
                    {enrollmentFormData && enrollmentFormData.icd10Codes && enrollmentFormData.icd10Codes.length && enrollmentFormData.icd10Codes.map((code, i) => <li key={i}>{`${code.id} - ${code.name}`}</li>)}
                  </ul>
                </div>
              </div>
            </div>}
            { !enrollmentFlag && connectionStatus !== 'pending' ?
              <div className={styles.editLabelGroup}>
                <div className={styles.noEditIcon} />
                <div className={styles.inputGroup}>
                  <span className={styles.label}>Connection Period</span>
                  <div className={styles.fakeInput}>
                    {renderEnrollmentDates()}
                  </div>
                </div>
              </div>
              :
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
              </div>
            }
        </div> :
        <div className={styles.editEnrollmentSection}>
        <div className={styles.formSectionRow}>
          <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            <div className={styles.noEditIcon} />
            <div className={styles.inputGroup}>
              <span className={styles.required} />
              <span className={styles.label}>Connection Plan</span>
              <div className={styles.fakeInput}>
                {connectionTemplateName}
              </div>
            </div>
          </div>
          <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            <div className={styles.noEditIcon} />
            <div className={styles.inputGroup}>
              <span className={styles.label}>Duration</span>
              <div className={styles.fakeInput}>
                {duration}
              </div>
            </div>
          </div>
          <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            <div className={styles.noEditIcon} />
            <div className={styles.inputGroup}>
              <span className={styles.required} />
              <span className={styles.label}>Connection Plan</span>
              <div className={styles.fakeInput}>
                {connectionTemplateName}
              </div>
            </div>
          </div>
          {isIdtfEnabled && enrollmentFlag && enrollmentData &&
          <div style={{ display: 'block' }} className={styles.editLabelGroup}>
            <div className={styles.noEditIcon} />
            <div className={styles.inputGroup}>
              <span className={styles.label}>Indication</span>
              <div className={styles.fakeInputIndication}>
                <ul>
                  {enrollmentFormData && enrollmentFormData.icd10Codes && enrollmentFormData.icd10Codes.length && enrollmentFormData.icd10Codes.map((code, i) => <li key={i}>{`${code.id} - ${code.name}`}</li>)}
                </ul>
              </div>
            </div>
          </div>}
          {!enrollmentFlag && connectionStatus !== 'pending' ?
            <div className={styles.editLabelGroup}>
              <div className={styles.noEditIcon} />
              <div className={styles.inputGroup}>
                <span className={styles.label}>Connection Period</span>
                <div className={styles.fakeInput}>
                  {renderEnrollmentDates()}
                </div>
              </div>
            </div>
            :
            <div className={styles.editLabelGroup}>
              <div className={styles.editPlaceholder} />
            </div>
          }
        </div>
      </div>
        }
        {
          !enrollmentFlag &&
          <div className={styles.editEnrollmentSection}>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('icd10Codes')]} onClick={() => this.toggleDisable('icd10Codes')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Primary Indication"
                  name="icd10Codes"
                  isLoading={icd10Codes && icd10Codes.isFetching}
                  placeholder="ICD-10 Lookup"
                  options={icd10Options}
                  noOptionsMessage="No codes found"
                  getOptionLabel={p => p.name}
                  getOptionValue={p => p.id}
                  disabled={disabled.icd10Codes}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('billingCodes')]} onClick={() => this.toggleDisable('billingCodes')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Billing Code"
                  name="billingCodes"
                  isLoading={billingCodes && billingCodes.isFetching}
                  placeholder="Select Billing Code"
                  options={billingOptions}
                  noOptionsMessage="No codes found"
                  getOptionLabel={p => p.name}
                  getOptionValue={p => p.id}
                  disabled={disabled.billingCodes}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('orderNumber')]} onClick={() => this.toggleDisable('orderNumber')}>
                  <EditIcon />
                </div>
                <Field
                  component={TextInput}
                  placeholder="Enter EHR Order Number"
                  label="EHR Order Number"
                  name="orderNumber"
                  disabled={disabled.orderNumber}
                />
              </div>
            </div>
            <div className={styles.formSectionRow}>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('ekgReviewWhichRecordings')]} onClick={() => this.toggleDisable('ekgReviewWhichRecordings')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Which Recordings to Flag"
                  placeholder="Which Recordings to Flag"
                  name="ekgReviewWhichRecordings"
                  isLoading={triggers && triggers.isFetching}
                  isClearable={false}
                  backspaceRemovesValue={false}
                  options={triggerOptions}
                  noOptionsMessage="No recording type found"
                  getOptionLabel={p => p.label}
                  getOptionValue={p => p.id}
                  disabled={disabled.ekgReviewWhichRecordings}
                />
                {isCustomSelected &&
                (
                  <div className={styles.customRules}>
                    <h3>Custom Rules</h3>
                    <Field
                      component={CheckboxInput}
                      label="Possible AFib result"
                      name="custom.possibleAFibResultCheckmark"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!(isPossibleAFibResultWithHrCheckmarked && !disabled.ekgReviewWhichRecordings)}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Possible AFib result with heart rate over"
                          name="custom.possibleAFibResultWithHrCheckmark"
                          disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                        />
                      )}
                      name="custom.possibleAFibResultWithHr"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with Wide QRS"
                      name="custom.sinusRhythmWithWideQRS"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with SVE"
                      name="custom.sinusRhythmWithSVEs"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with PVCs"
                      name="custom.sinusRhythmWithPVCs"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={CheckboxInput}
                      label="Tachycardia"
                      name="custom.tachycardia"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={CheckboxInput}
                      label="Bradycardia"
                      name="custom.bradycardia"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={CheckboxInput}
                      label="Unclassified result"
                      name="custom.unclassifiedResultCheckmark"
                      disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!(isHeartRateUnderCheckmarked && !disabled.ekgReviewWhichRecordings)}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Heart rate under"
                          name="custom.heartRateUnderCheckmark"
                          disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                        />
                      )}
                      name="custom.heartRateUnder"
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!(isHeartRateOverCheckmarked && !disabled.ekgReviewWhichRecordings)}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Heart rate over"
                          name="custom.heartRateOverCheckmark"
                          disabled={!(isCustomSelected && !disabled.ekgReviewWhichRecordings)}
                        />
                      )}
                      name="custom.heartRateOver"
                    />
                  </div>
                )
                }
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles[getEditClassName('ekgReviewWhereRecordings')]} onClick={() => this.toggleDisable('ekgReviewWhereRecordings')}>
                  <EditIcon />
                </div>
                <Field
                  component={ReactSelectDropdownInput}
                  label="Flagged Recordings Go to"
                  placeholder="Flagged Recordings Go to"
                  name="ekgReviewWhereRecordings"
                  isLoading={physicians && physicians.isFetching}
                  isClearable={false}
                  backspaceRemovesValue={false}
                  options={physiciansOptions}
                  noOptionsMessage="No recording location found"
                  getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                  getOptionValue={p => p.id}
                  disabled={disabled.ekgReviewWhereRecordings}
                />
              </div>
              <div className={styles.editLabelGroup}>
                <div className={styles.editPlaceholder} />
              </div>
            </div>
          </div>
        }

        {enrollmentFlag && (isIdtfEnabled || isIdtfServiceEnabled) &&
        <div style={{fontSize: '20px'}}>
          {`Enrollment entered by ${userCreatedBy} at ${userCreatedAt} and electronically authorized by ${referringPhysicaian}`}
        </div>
        }
        <div className={styles.enrollmentSubmitWrapper}>
          <div className={styles.buttonWrapper}>
            {isIdtfEnabled && buttonState.show &&
              <div style={{marginRight: '20px'}}>
                <button
                  type="button"
                  className={styles.PrimaryButton}
                  onClick={() => this.toggleRevokePopover()}
                  data-action="button-cancel-order"
                  data-label="revoke"
                >
                  {buttonState.revoke ? 'REVOKE' : 'EARLY TERMINATE'}
                </button>
                {revokeConfirmShow &&
                  <Popover
                    onOutsidePopoverClick={() => this.cancelRevoke()}
                    className={styles.dropover}
                  >
                    {renderIdtfRevokeContent()}
                  </Popover>
                }
              </div>
            }
             {
              isIdtfEnabled &&  !enrollmentFlag  && showRevoke &&
              <div>
                <button
                  type="button"
                  className={styles.cancel}
                  onClick={() => this.toggleRevokePopover()}
                  data-action="button-cancel-order"
                  data-label="revoke"
                >
                  <CancelIcon />
                  Revoke
                </button>
                {revokeConfirmShow &&
                  <Popover
                    onOutsidePopoverClick={() => this.cancelRevoke()}
                    className={styles.dropover}
                  >
                    {renderRevokeContent()}
                  </Popover>
                }
              </div>
            }
            {
              isIdtfEnabled && enrollmentFlag && !isIdtfServiceEnabled &&
              <div>
                <button
                  type="button"
                  className={styles.cancel}
                  onClick={() => this.printPage()}
                  data-action="button-cancel-order"
                  data-label="revoke"
                >
                  <img className={styles.printIcon} src={PrintIcon} />
                  Print
                </button>
              </div>
            }
            {!isIdtfEnabled && showRevoke &&
              <div>
                <button
                  type="button"
                  className={styles.cancel}
                  onClick={() => this.toggleRevokePopover()}
                  data-action="button-cancel-order"
                  data-label="revoke"
                >
                  <CancelIcon />
                  Revoke
                </button>
                {revokeConfirmShow &&
                  <Popover
                    onOutsidePopoverClick={() => this.cancelRevoke()}
                    className={styles.dropover}
                  >
                    {renderRevokeContent()}
                  </Popover>
                }
              </div>
            }
            {submitting || isSubmitting ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              !enrollmentFlag &&
              <button
                type="submit"
                disabled={invalid || pristine}
                className={styles.submit}
                data-action="button-edit-order"
                data-label="save"
              >
                <SaveIcon />
                Save
              </button>
            }
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'enrollmentForm',
  enableReinitialize: true,
})(EnrollmentForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/EnrollmentForm.jsx